<ul class="nav flex-column">
  <div *ngFor="let item of sideMenuItems">
    <li class="nav-item parent {{currentLang == 'en' ? 'eng' : ''}} ">
      <i class="nav-item-icon-norm {{item.itemIcon}}"></i>
      <a class="nav-link parent-link" *ngIf="!item.external_url" [routerLink]="!item.old ? ['/pages/page/'+mainSlug+'/'+item.id] : [mainSlug + '/' + item.slug]"
        routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        (click)="checkForMenuLevels(item.id)">{{currentLang == 'ar' ? item.title :
        item.title_en}}</a>
        <a class="nav-link parent-link" *ngIf="item.external_url" [href]="item.external_url">{{currentLang == 'ar' ? item.title :
        item.title_en}}</a>
    </li>
    <div *ngIf=" childMenuItems.items?.length > 0 && childMenuItems.id == item.id">
      <li class="nav-item child" *ngFor="let childItem of childMenuItems.items">
        <i class="nav-item-icon-child fas fa-chevron-left fa-2x"></i>
        <a class="nav-link" [routerLink]="['/pages/page/'+childItem.id]" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" *ngIf="!item.external_url">
          {{currentLang == 'ar' ? childItem.title : childItem.title_en}}</a>
          <a class="nav-link" *ngIf="item.external_url" [href]="item.external_url">
          {{currentLang == 'ar' ? childItem.title : childItem.title_en}}</a>
      </li>
    </div>
  </div>
</ul>
<!-- for fraud types sub menu -->
<ul class="nav flex-column" *ngIf="fraud" id="fraud-sideMenu">
  <div *ngFor="let item of fraudMenuItems">
    <li class="nav-item parent {{currentLang == 'en' ? 'eng' : ''}} {{item.id == currentTab? 'active' : ''}}">
      <a class="nav-link parent-link " [routerLink]="['fraud/fraudDetails/', item.id]" routerLinkActive="active"
      (click)="changeTab(item.id)">
      <img [src]="getImage(item.image)" alt=""  class="nav-item-icon">
        {{currentLang == 'ar' ? item.title : item.title_en}}
      </a>
    </li>
    <div *ngIf="item.id==currentTab">
      <li class="nav-item child {{currentLang == 'en' ? 'eng' : ''}}"
        *ngFor="let childItem of item.fraud_type_categories">
        <i class="nav-item-icon-child fas fa-chevron-left fa-2x"></i>
        <a class="nav-link" [routerLink]="['fraud/fraudSubDetails/', item.id + ',' + childItem.id]"
          routerLinkActive="sub-tab-active" [routerLinkActiveOptions]="{exact: true}">{{currentLang == 'ar' ?
          childItem.title :
          childItem.title_en}}</a>
      </li>
    </div>
  </div>
</ul>
<!-- (click)="onChildClick('off')" -->